import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import customIcons from '../../styles/icons';
import iconColors from './colors';
import { fonts } from '../../styles/theme';

import * as iconVariants from './styles';

const getDefaultColor = (props) => {
  if (props.color) {
    return props.color;
  }
  if (iconColors[props.type]) {
    return iconColors[props.type].normal;
  }
  return '';
};

export const Icon = styled('i')`
  font-style: inherit;
  color: ${(props) => getDefaultColor(props)};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  &::before {
    ${fonts.icons};
    content: '${(props) => customIcons[props.type]}';
    line-height: inherit;
    color: inherit;
  }
  &:hover {
    color: ${(props) => (iconColors[props.type] ? iconColors[props.type].hover : '')};
  }
  ${(props) => (props.withText ? iconVariants.withText : '')};
  ${(props) => (props.withTextLeft ? iconVariants.withTextLeft : '')};
  ${(props) => (props.fixedWidth ? iconVariants.fixedWidth : '')};
  ${(props) => (props.flip ? iconVariants.flip : '')};
  ${(props) => (props.spin ? iconVariants.spin : '')};
`;

Icon.defaultProps = {
  withText: false,
  withTextLeft: false,
  fixedWidth: true,
  spin: '',
  flip: '',
  color: null,
  children: null,
};

Icon.propTypes = {
  withText: PropTypes.bool,
  withTextLeft: PropTypes.bool,
  spin: PropTypes.string,
  fixedWidth: PropTypes.bool,
  flip: PropTypes.string,
  type: PropTypes.string.isRequired,
  color: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
};
